import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, RefreshCw, ServerCrash } from 'lucide-react';
import './ErrorPages.css';

const ServerError = () => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="error-icon-wrapper server-error">
            <ServerCrash size={80} className="error-icon" />
          </div>
        </div>

        <h1 className="error-code">500</h1>
        <h2 className="error-title">Internal Server Error</h2>
        <p className="error-description">
          Oops! Something went wrong on our end. Our team has been notified and is working to fix the issue.
        </p>

        <div className="error-actions">
          <button onClick={handleRefresh} className="error-button primary">
            <RefreshCw size={20} />
            <span>Refresh Page</span>
          </button>
          <Link to="/" className="error-button secondary">
            <Home size={20} />
            <span>Go Home</span>
          </Link>
        </div>

        <div className="error-help">
          <p>Issue persists? <a href="#">Report this Problem to you admin</a></p>
        </div>
      </div>
    </div>
  );
};

export default ServerError;
